import { ObjectLiteral } from '~/types/generics';

import { IReportTypes, IReport, IGeneratedReport } from './types';

export function getReportsRequest(params: ObjectLiteral) {
  return {
    type: IReportTypes.GET_REPORTS_REQUEST,
    payload: { params },
  };
}
export function getReportsSuccess(reports: IReport[], totalReports: number) {
  return {
    type: IReportTypes.GET_REPORTS_SUCCESS,
    payload: { reports, totalReports },
  };
}
export function getReportsFailure() {
  return {
    type: IReportTypes.GET_REPORTS_FAILURE,
  };
}

export function generateReportRequest(params: ObjectLiteral) {
  return {
    type: IReportTypes.GENERATE_REPORT_REQUEST,
    payload: { params },
  };
}
export function generateReportSuccess() {
  return {
    type: IReportTypes.GENERATE_REPORT_SUCCESS,
  };
}
export function generateReportFailure() {
  return {
    type: IReportTypes.GENERATE_REPORT_FAILURE,
  };
}

export function getGeneratedReportsRequest(id: number, params: ObjectLiteral) {
  return {
    type: IReportTypes.GET_GENERATED_REPORTS_REQUEST,
    payload: { id, params },
  };
}
export function getGeneratedReportsSuccess(
  generatedReports: IGeneratedReport[],
  totalGeneratedReports: number,
) {
  return {
    type: IReportTypes.GET_GENERATED_REPORTS_SUCCESS,
    payload: { generatedReports, totalGeneratedReports },
  };
}
export function getGeneratedReportsFailure() {
  return {
    type: IReportTypes.GET_GENERATED_REPORTS_FAILURE,
  };
}
